import { LmIconFilledBusinessBriefcase, LmIconOutlineBusinessBriefcase } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionJobsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineBusinessBriefcase {...rest} /> : <LmIconFilledBusinessBriefcase {...rest} />;

export default IconProfessionJobsCommon;
